/*********************** Custom JS for Boost AI Search & Discovery ************************/

// Merge Boost integration settings
if (window.boostSDAppConfig) {
  window.boostSDAppConfig.integration = Object.assign({
    wishlists: 'plus'
  }, window.boostSDAppConfig.integration || {});
}

// Ensure themeInfo tweaks
if(window.boostSDAppConfig){
  window.boostSDAppConfig = {
    ...window.boostSDAppConfig,
    themeInfo: {
      ...window.boostSDAppConfig.themeInfo,
      taeFeatures: {
        ...window.boostSDAppConfig.themeInfo.taeFeatures,
        instantSearch: "installed"
      }
    }
  }
}

window.__boostInstantSearchState = window.__boostInstantSearchState || {
  productsByHandle: new Map(),
  meta: {}
};

function ensureThemeEditorBodyVisible() {
  const isThemeEditor = Boolean(
    window.Shopify &&
      (window.Shopify.designMode || window.Shopify.visualPreviewMode)
  );
  if (!isThemeEditor) return;

  const unhideBody = () => {
    if (!document.body) return;
    if (document.body.style.display === 'none') {
      document.body.style.display = '';
    }
  };

  const init = () => {
    unhideBody();

    const bodyObserver = new MutationObserver(unhideBody);
    bodyObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['style']
    });

    ['shopify:section:load', 'shopify:section:reorder', 'shopify:block:select'].forEach((eventName) => {
      document.addEventListener(eventName, unhideBody);
    });

    let retries = 0;
    const intervalId = setInterval(() => {
      unhideBody();
      retries += 1;
      if (retries >= 40) clearInterval(intervalId);
    }, 250);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}

ensureThemeEditorBodyVisible();

function setBoostInstantSearchState(payload) {
  if (!payload || !Array.isArray(payload.products)) return;

  const productsByHandle = new Map();
  payload.products.forEach((product) => {
    if (product?.handle) {
      productsByHandle.set(product.handle, product);
    }
  });

  window.__boostInstantSearchState = {
    productsByHandle,
    meta: payload.meta || {}
  };
}

function interceptBoostInstantSearchResponse() {
  if (window.__boostInstantSearchIntercepted) return;
  window.__boostInstantSearchIntercepted = true;

  const originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = function(...args) {
      return originalFetch.apply(this, args).then((response) => {
        try {
          const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;
          if (url && url.includes('/bc-sf-filter/search/suggest')) {
            response.clone().json().then(setBoostInstantSearchState).catch(() => {});
          }
        } catch (error) {
          console.warn(error);
        }

        return response;
      });
    };
  }

  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    this.__boostSuggestUrl = url;
    return originalOpen.call(this, method, url, ...rest);
  };

  XMLHttpRequest.prototype.send = function(...args) {
    this.addEventListener('load', function() {
      try {
        if (
          this.__boostSuggestUrl &&
          this.__boostSuggestUrl.includes('/bc-sf-filter/search/suggest') &&
          typeof this.responseText === 'string'
        ) {
          setBoostInstantSearchState(JSON.parse(this.responseText));
        }
      } catch (error) {
        console.warn(error);
      }
    });

    return originalSend.apply(this, args);
  };
}

// Swym + Recommendation Widget Fix
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin('RecommendationWidget.Slider', {
      name: 'Fix wishlist plus integration',
      apply: () => ({
        afterRender(element) {
          try {
            const widgetElm = componentRegistry.getNearestParentElm(element, 'RecommendationWidget');
            const widgetId = widgetElm?.getParams()?.props?.designSettings?.widgetId || '';

            function swymCallbackFn(swat) {
              document.addEventListener("swym:collections-loaded", function () {
                swat.initializeActionButtons(`#boost-sd-widget-${widgetId} .slick-track`);
              });
            }

            if (!window.SwymCallbacks) window.SwymCallbacks = [];
            window.SwymCallbacks.push(swymCallbackFn);

            setTimeout(() => {
              document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
            }, 300);
          } catch (error) {
            console.warn(error);
          }
        },
      }),
    });
  }
]);

// Swiper for Boost Instant Search
function initBoostInstantSearchCarousel() {
  const instantSearchSwiperMap = new WeakMap();
  let instantSearchId = 0;
  interceptBoostInstantSearchResponse();

  function getArrowIcon(direction) {
    if (direction === 'next') {
      return '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
          '<circle opacity="0.2" cx="20" cy="20" r="20" fill="black"/>\n' +
          '<path d="M25.0306 20.5307L17.5306 28.0307C17.4609 28.1004 17.3781 28.1556 17.2871 28.1933C17.1961 28.2311 17.0985 28.2505 16.9999 28.2505C16.9014 28.2505 16.8038 28.2311 16.7128 28.1933C16.6217 28.1556 16.539 28.1004 16.4693 28.0307C16.3996 27.961 16.3443 27.8783 16.3066 27.7872C16.2689 27.6962 16.2495 27.5986 16.2495 27.5001C16.2495 27.4015 16.2689 27.3039 16.3066 27.2129C16.3443 27.1218 16.3996 27.0391 16.4693 26.9694L23.4396 20.0001L16.4693 13.0307C16.3286 12.8899 16.2495 12.6991 16.2495 12.5001C16.2495 12.301 16.3286 12.1102 16.4693 11.9694C16.61 11.8287 16.8009 11.7496 16.9999 11.7496C17.199 11.7496 17.3898 11.8287 17.5306 11.9694L25.0306 19.4694C25.1003 19.5391 25.1556 19.6218 25.1933 19.7128C25.2311 19.8039 25.2505 19.9015 25.2505 20.0001C25.2505 20.0986 25.2311 20.1962 25.1933 20.2873C25.1556 20.3783 25.1003 20.461 25.0306 20.5307Z" fill="black"/>\n' +
          '</svg>\n';
    }

    return '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<circle opacity="0.2" cx="20" cy="20" r="20" fill="black"/>\n' +
        '<path d="M25.0306 20.5307L17.5306 28.0307C17.4609 28.1004 17.3781 28.1556 17.2871 28.1933C17.1961 28.2311 17.0985 28.2505 16.9999 28.2505C16.9014 28.2505 16.8038 28.2311 16.7128 28.1933C16.6217 28.1556 16.539 28.1004 16.4693 28.0307C16.3996 27.961 16.3443 27.8783 16.3066 27.7872C16.2689 27.6962 16.2495 27.5986 16.2495 27.5001C16.2495 27.4015 16.2689 27.3039 16.3066 27.2129C16.3443 27.1218 16.3996 27.0391 16.4693 26.9694L23.4396 20.0001L16.4693 13.0307C16.3286 12.8899 16.2495 12.6991 16.2495 12.5001C16.2495 12.301 16.3286 12.1102 16.4693 11.9694C16.61 11.8287 16.8009 11.7496 16.9999 11.7496C17.199 11.7496 17.3898 11.8287 17.5306 11.9694L25.0306 19.4694C25.1003 19.5391 25.1556 19.6218 25.1933 19.7128C25.2311 19.8039 25.2505 19.9015 25.2505 20.0001C25.2505 20.0986 25.2311 20.1962 25.1933 20.2873C25.1556 20.3783 25.1003 20.461 25.0306 20.5307Z" fill="black"/>\n' +
        '</svg>';
  }

  function createButton(type, label) {
    const wrapper = document.createElement('div');
    wrapper.className = `custom-swiper-btn boost-sd-search-carousel__arrow custom-swiper-${type} boost-sd-search-carousel__arrow--${type}`;
    wrapper.setAttribute('role', 'button');
    wrapper.setAttribute('tabindex', '0');
    wrapper.setAttribute('aria-label', label);
    wrapper.innerHTML = getArrowIcon(type);
    return wrapper;
  }

  function getProductHandleFromItem(item) {
    const url = item.querySelector('a[href*="/products/"]')?.getAttribute('href') || '';
    const matched = url.match(/\/products\/([^/?#]+)/);
    return matched ? matched[1] : '';
  }

  function getProductBadge(product) {
    const labels = Array.isArray(product?.tags) ? product.tags : [];
    return labels.find((tag) => tag && !/dummy/i.test(tag)) || labels[0] || '';
  }

  function getVariantId(product) {
    const variants = Array.isArray(product?.variants) ? product.variants : [];
    const availableVariant = variants.find((variant) => variant?.available);
    return availableVariant?.id || variants[0]?.id || '';
  }

  function formatBoostMoney(value) {
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) return '';
    const hasDecimals = Math.abs(numeric % 1) > 0;
    const formatter = new Intl.NumberFormat('id-ID', {
      minimumFractionDigits: hasDecimals ? 2 : 0,
      maximumFractionDigits: hasDecimals ? 2 : 0
    });

    return `Rp ${formatter.format(numeric)}`;
  }

  function buildProductPrice(product) {
    const price = Number(product?.price_min ?? product?.price_max ?? 0);
    const compareAt = Number(product?.compare_at_price_min ?? product?.compare_at_price_max ?? 0);

    if (compareAt > price && price > 0) {
      const discount = Math.round(((compareAt - price) / compareAt) * 100);
      return `
        <div class="product-price">
          <div class="price-wraper">
            <span class="compare-price">${formatBoostMoney(compareAt)}</span>
            <span class="sale-price">${formatBoostMoney(price)}</span>
          </div>
          <span class="discount-percent">${discount}%</span>
        </div>
      `;
    }

    return `
      <div class="product-price">
        <span class="regular">${formatBoostMoney(price)}</span>
      </div>
    `;
  }

  function buildProductCardMarkup(item, product) {
    const href = item.querySelector('a[href]')?.getAttribute('href') || `/products/${product.handle}`;
    const image = product?.images_info?.[0]?.src || product?.images?.['1'] || '';
    const badge = getProductBadge(product);
    const variantId = getVariantId(product);

    return `
      <div class="custom-product-card boost-search-product-card">
        <a href="${href}">
          <div class="custom-product-image">
            ${badge ? `<div class="product-tag-badge">${badge}</div>` : ''}
            ${
              variantId
                ? `<div class="wishlist-engine swym-button swym-add-to-wishlist-view-product product_${product.id}" data-product_id="${product.id}" data-variant_id="${variantId}" data-full_button="false" data-css="true"></div>`
                : ''
            }
            ${image ? `<img src="${image}" alt="${product.title}">` : ''}
          </div>
          <div class="custom-product-info">
            <div class="product-vendor">${product.vendor || ''}</div>
            <span class="product-title">${product.title || ''}</span>
            ${buildProductPrice(product)}
          </div>
        </a>
      </div>
    `;
  }

  function hydrateProductCards(productList) {
    const { productsByHandle } = window.__boostInstantSearchState || {};
    if (!productsByHandle?.size) return;

    const items = productList.querySelectorAll('.boost-sd__suggestion-queries-item--product');
    items.forEach((item) => {
      const handle = getProductHandleFromItem(item);
      const product = productsByHandle.get(handle);

      if (!product) return;
      if (item.dataset.boostRenderedHandle === handle) return;

      const link = item.querySelector('.boost-sd__suggestion-queries-item-link');
      if (!link) return;

      link.innerHTML = buildProductCardMarkup(item, product);
      item.dataset.boostRenderedHandle = handle;
    });

    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('swym:collections-loaded'));
    }, 0);
  }

  function ensureCarouselStructure(productList) {
    const list = productList.querySelector('.boost-sd__instant-search-product-list-items');
    if (!list) return null;

    const instance = instantSearchSwiperMap.get(list);
    if (instance && list.isConnected) {
      return {
        list,
        viewport: productList.querySelector('.boost-sd-search-carousel__viewport'),
        pagination: productList.querySelector('.boost-sd-search-carousel__pagination'),
        prevButton: productList.querySelector('.boost-sd-search-carousel__arrow--prev'),
        nextButton: productList.querySelector('.boost-sd-search-carousel__arrow--next')
      };
    }

    if (!list.dataset.boostCarouselId) {
      instantSearchId += 1;
      list.dataset.boostCarouselId = `boost-search-carousel-${instantSearchId}`;
    }

    let viewport = productList.querySelector('.boost-sd-search-carousel__viewport');
    if (!viewport) {
      viewport = document.createElement('div');
      viewport.className = 'boost-sd-search-carousel__viewport swiper';
      list.parentNode.insertBefore(viewport, list);
      viewport.appendChild(list);
    }

    let controls = productList.querySelector('.custom-navigation');
    if (!controls) {
      controls = document.createElement('div');
      controls.className = 'custom-navigation boost-sd-search-carousel__controls';
      const header = productList.querySelector('.boost-sd__instant-search-product-list-header');
      if (header) {
        header.insertAdjacentElement('afterend', controls);
      } else {
        productList.insertBefore(controls, viewport);
      }
    }

    let prevButton = productList.querySelector('.boost-sd-search-carousel__arrow--prev');
    if (!prevButton) {
      prevButton = createButton('prev', 'Previous products');
      controls.appendChild(prevButton);
    }

    let pagination = productList.querySelector('.boost-sd-search-carousel__pagination');
    if (!pagination) {
      pagination = document.createElement('div');
      pagination.className = 'boost-sd-search-carousel__pagination';
      controls.appendChild(pagination);
    }

    let nextButton = productList.querySelector('.boost-sd-search-carousel__arrow--next');
    if (!nextButton) {
      nextButton = createButton('next', 'Next products');
      controls.appendChild(nextButton);
    }

    list.classList.add('swiper-wrapper');
    Array.from(list.children).forEach((item) => item.classList.add('swiper-slide'));
    productList.classList.add('boost-sd-search-carousel', 'boost-sd-search-carousel--ready');

    return { list, viewport, pagination, prevButton, nextButton };
  }

  function syncCarouselState(swiper, productList) {
    const controls = productList.querySelector('.boost-sd-search-carousel__controls');
    if (!controls) return;

    const shouldHideControls = swiper.slides.length <= Math.ceil(swiper.params.slidesPerView || 1);
    //controls.classList.toggle('is-hidden', shouldHideControls);
  }

  function initCarousel(productList) {
    if (typeof Swiper === 'undefined') return;

    hydrateProductCards(productList);

    const structure = ensureCarouselStructure(productList);
    if (!structure) return;

    const { list, viewport, pagination, prevButton, nextButton } = structure;
    const currentInstance = instantSearchSwiperMap.get(list);

    if (currentInstance) {
      currentInstance.update();
      syncCarouselState(currentInstance, productList);
      return;
    }

    const swiper = new Swiper(viewport, {
      slidesPerView: 5.22,
      spaceBetween: 15,
      watchOverflow: true,
      observer: true,
      observeParents: true,

      navigation: {
        nextEl: nextButton,
        prevEl: prevButton
      },

      pagination: {
        el: pagination,
        clickable: true,
        bulletClass: 'boost-sd-search-carousel__dot',
        bulletActiveClass: 'is-active'
      },

      breakpoints: {
        0: {
          slidesPerView: 2.28,
          spaceBetween: 9
        },
        768: {
          slidesPerView: 3.1,
          spaceBetween: 15
        },
        1000: {
          slidesPerView: 5.22,
          spaceBetween: 15
        },
      },
      
      on: {
        init() {
          syncCarouselState(this, productList);
        },
        resize() {
          syncCarouselState(this, productList);
        },
        breakpoint() {
          syncCarouselState(this, productList);
        },
        update() {
          syncCarouselState(this, productList);
        }
      }
    });

    instantSearchSwiperMap.set(list, swiper);
  }

  function initInstantSearchCarousels(root = document) {
    const lists = root.querySelectorAll('.boost-sd__instant-search-product-list');
    lists.forEach(initCarousel);
  }

  function updateViewAllButtons(root = document) {
    const viewAllElements = root.querySelectorAll('.boost-sd__view-all');
    const newSVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" class="boost-sd__view-all-icon" width="16" height="16"><path d="M439.1 297.4C451.6 309.9 451.6 330.2 439.1 342.7L279.1 502.7C266.6 515.2 246.3 515.2 233.8 502.7C221.3 490.2 221.3 469.9 233.8 457.4L371.2 320L233.9 182.6C221.4 170.1 221.4 149.8 233.9 137.3C246.4 124.8 266.7 124.8 279.2 137.3L439.2 297.3z"/></svg>';

    viewAllElements.forEach((viewAllElement) => {
      const textSpan = viewAllElement.querySelector('.boost-sd__view-all-text');
      if (textSpan) {
        // Replace the text content while preserving the SVG structure
        const oldSVG = textSpan.querySelector('.boost-sd__view-all-icon');
        textSpan.innerHTML = 'VIEW ALL PRODUCTS' + newSVG;
      }
    });
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        if (node.matches('.boost-sd__instant-search-product-list')) {
          initCarousel(node);
          return;
        }

        if (node.matches('.boost-sd__view-all')) {
          updateViewAllButtons(node.parentElement);
          return;
        }

        if (node.querySelector?.('.boost-sd__instant-search-product-list')) {
          initInstantSearchCarousels(node);
        }

        if (node.querySelector?.('.boost-sd__view-all')) {
          updateViewAllButtons(node);
        }
      });
    });
  });

  initInstantSearchCarousels();
  updateViewAllButtons();
  observer.observe(document.body, { childList: true, subtree: true });

  window.addEventListener('resize', () => {
    initInstantSearchCarousels();
  });

  // Ensure empty brands display
  document.querySelectorAll(".empty-search-brands").forEach(el => el.style.display = "block");
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBoostInstantSearchCarousel);
} else {
  initBoostInstantSearchCarousel();
}
